export default function About() {
  return (
    <div style={page}>
      {/* HERO */}
      <div style={hero}>
        <h1 style={title}>About DIET Dubacherla</h1>
        <p style={subtitle}>
          Building future-ready teachers through quality education and innovation
        </p>
      </div>

      {/* CONTENT BOX */}
      <div style={card}>
        <p style={text}>
          District Institute of Education and Training (DIET), Dubacherla is a
          premier teacher education institution dedicated to preparing competent
          and committed teachers for the future.
        </p>
      </div>

      {/* VISION + MISSION GRID */}
      <div style={grid}>
        <div style={box}>
          <h2 style={heading}>🎯 Vision</h2>
          <p style={text}>
            To develop quality teachers capable of building a knowledgeable and
            responsible society.
          </p>
        </div>

        <div style={box}>
          <h2 style={heading}>🚀 Mission</h2>
          <ul style={list}>
            <li>Provide quality teacher education</li>
            <li>Promote innovative teaching methods</li>
            <li>Develop professional competencies</li>
            <li>Encourage lifelong learning</li>
          </ul>
        </div>
      </div>

      {/* HIGHLIGHTS */}
      <div style={stats}>
        <Stat title="30+" label="Years Excellence" />
        <Stat title="5000+" label="Teachers Trained" />
        <Stat title="100%" label="NCTE Approved" />
      </div>
      {/* YOUTUBE SECTION */}
<div style={socialCard}>
  <h2 style={heading}>📺 Follow Our YouTube Channel</h2>

  <p style={text}>
    Watch educational videos, training programs, workshops, events,
    and updates from DIET Dubacherla on our official YouTube channel.
  </p>

  <a
    href="https://youtube.com/@dietwestgodavari2023?si=uuwHqRz416gk1Bz0"
    target="_blank"
    rel="noopener noreferrer"
    style={youtubeBtn}
  >
    ▶ Visit YouTube Channel
  </a>
</div>
    </div>
  );
}

/* ---------- COMPONENT ---------- */
function Stat({ title, label }) {
  return (
    <div style={statCard}>
      <h1 style={{ color: "#b30000", margin: 0 }}>{title}</h1>
      <p style={{ margin: 0, color: "#555" }}>{label}</p>
    </div>
  );
}

/* ---------- STYLES ---------- */

const page = {
  background: "#f4f6fb",
  minHeight: "100vh",
  padding: "40px 20px",
};

const hero = {
  textAlign: "center",
  marginBottom: "30px",
};

const title = {
  color: "#b30000",
  fontSize: "32px",
  marginBottom: "10px",
};

const subtitle = {
  color: "#666",
  fontSize: "16px",
};

const card = {
  background: "white",
  padding: "25px",
  borderRadius: "15px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  maxWidth: "900px",
  margin: "0 auto 25px",
};

const text = {
  lineHeight: 1.8,
  color: "#444",
  fontSize: "16px",
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  gap: "20px",
  maxWidth: "900px",
  margin: "0 auto",
};

const box = {
  background: "white",
  padding: "25px",
  borderRadius: "15px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
};

const heading = {
  color: "#b30000",
  marginBottom: "10px",
};

const list = {
  lineHeight: 1.8,
  color: "#444",
  paddingLeft: "20px",
};

const stats = {
  display: "flex",
  justifyContent: "center",
  gap: "20px",
  flexWrap: "wrap",
  marginTop: "30px",
};

const statCard = {
  background: "white",
  padding: "20px",
  borderRadius: "12px",
  width: "180px",
  textAlign: "center",
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
};

const socialCard = {
  background: "white",
  padding: "25px",
  borderRadius: "15px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  maxWidth: "900px",
  margin: "25px auto",
  textAlign: "center",
};

const youtubeBtn = {
  display: "inline-block",
  marginTop: "15px",
  background: "#FF0000",
  color: "#fff",
  textDecoration: "none",
  padding: "12px 24px",
  borderRadius: "8px",
  fontWeight: "bold",
  transition: "0.3s",
};